exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".support-btn[data-v-6785b414]{background:#15161c!important;border-radius:6px;color:#fff!important;font-weight:800;min-height:42px}.support-dialog[data-v-6785b414]{border-radius:8px!important;padding:12px}.dialog-title[data-v-6785b414]{color:#17181e;justify-content:flex-start!important}.dialog-title h3[data-v-6785b414]{font-size:1.2rem;font-weight:800;margin:0}.submit-btn[data-v-6785b414]{background:#c52a49!important;color:#fff!important;font-weight:800}.secondary-btn[data-v-6785b414]{background:#eee8df!important;color:#302d29!important;font-weight:800}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6785b414","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/persons/components/AddPerson.vue
// module id = 41
// module chunks = 0